<template>
  <div class="home-page">
    <section class="masthead hero-text-section" id="hero-section">
      <div class="container-fluid px-0 px-lg-3">
        <div class="hero-section">
          <div class="hero-section-container">
            <div class="content-area">
              <!-- <h1 class="title">PLUG IN. PLAY YOUR FAVOURITE STREAM</h1> -->
              <h1 class="title">
                Overseas Education Consultants.
              </h1>
              <!-- <p class="para">
                Your dream of studying abroad awaits you! Let’s kickstart it
                together, right now. Make us a part of your journey and let’s
                rock it!
              </p> -->
              <p class="para">We make global education affordable.</p>
              <a href="#search-home" class="hero-cta">get started</a>
            </div>
            <div class="video-area">
              <center>
                <video autoPlay loop controls muted>
                  <source src="@/assets/promo-video.mp4" type="video/mp4" />
                  Your browser does not support HTML video.
                  <p>Overseas Education Consultants</p>
                </video>

              </center>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="hero-text-img-section">
      <div class="intro-tabs mx-lg-3 gradient-box bg-primary-gradient br-0">
        <div class="tabs w-100">
          <li class="tab-content">
            <img src="@/assets/imgs/home-logo-1.png" alt="Overseas Education Consultants" class="img-fluid" />
          </li>
          <li class="tab-content">
            <img src="@/assets/imgs/home-logo-2.png" alt="Overseas Education Consultants" />
          </li>
          <li class="tab-content">
            <img src="@/assets/imgs/home-logo-3.png" alt="Overseas Education Consultants" />
          </li>
          <li class="tab-content">
            <img src="@/assets/imgs/home-logo-4.png" alt="Overseas Education Consultants" />
          </li>
        </div>
      </div>
    </section>

    <section class="search-section">
      <div class="container-fluid">
        <div class="row justify-content-center">
          <div class="col-lg-10 px-0" data-aos="fade-down" data-aos-duration="500">
            <div class="search-box" id="search-home">
              <div class="input-field">
                <input type="text" class="form-control" placeholder="Where and what would you like to study?"
                  v-model="filter.searchText" @keydown="onKeySearch" />
                <div class="search-icon" @click="goToSearchPage">
                  <img src="@/assets/imgs/search-icon.svg" class="img-fluid" />
                </div>
              </div>
              <div class="search-tags" id="tags-home">
                <div class="tag" v-for="(tag, index) in search_tags" :key="index" data-aos="zoom-in"
                  @click="onClickSearchTag(tag)">
                  {{ tag.name }}
                </div>
              </div>
              <div class="pt-3 pt-lg-5">
                <p class="light-grey-3 text-center">
                  Choose across 460+ universities across 22+ countries
                </p>
              </div>
            </div>
          </div>
          <!-- <div class="col-lg-7 pt-4 pt-lg-5">
            <p class="primary-color text-center welcome-copy">
              Who said foreign education is a hassle? It is a breeze, when you
              plan it with us! Handpick your university or a destination of your
              choice, and leave the remaining to us!
            </p>
          </div> -->
        </div>
      </div>
    </section>

    <section class="py-5">
      <div class="container">
        <h1 class="text-center my-5">Explore Popular Fields of Study</h1>
        <div class="row">
          <div class="col-12 col-md-6 col-lg-3 mb-2 rounded" v-for="item in yourArray" :key="item.title">
            <div class="card">
              <div class="card-body text-center">
                <img :src="item.img" alt="" class="img-fluid mb-2">
                <h5 class="card-title m-0">{{ item.title }}</h5>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="stu-card-section section-spacing" data-aos="zoom-in">
      <TextTestimonialSlider :testimonialsData="testimonialData['home-page']['testimonial-1']" design="design-2" />
    </section>

    <TechServices />
    <section class="services-section section-spacing">
      <div class="container-fluid">
        <div class="row justify-content-center">
          <div class="col-lg-6 text-center" data-aos="fade-up" data-aos-duration="500">
            <h2 class="main-heading-1-gradient">Our Services</h2>
            <!-- <p class="main-content-1">
              Education Essentials – Personalised to suit your roadmap!
            </p> -->
            <p class="main-content-1">
              How We Make Your Global Dreams Come True
            </p>
          </div>
          <div class="col-lg-12 services-row mt-3 pt-lg-5" v-bind:style="{
            gridTemplateColumns:
              styleServicesRow[0] + styleServicesRow[1] + styleServicesRow[2]
          }">
            <div class="service-box" id="toggle1" @mouseover="showContent(1)"
              :class="serviceId == 1 ? 'show-content' : 'hide-content'">
              <div class="service-img">
                <img src="@/assets/imgs/services_studya.png" class="img-fluid" />
              </div>
              <div class="service-box-content">
                <div class="title">
                  <h4>STUDY ABROAD COUNSELLING</h4>
                </div>
                <hr class="line green-line" />
                <div class="content">
                  <p>
                    <!-- Your dream of studying abroad is actually the reality you
                    will be living and breathing in a few days. There is no stop
                    to that dream, as we help you realize it and achieve it
                    without any interruptions. -->
                    <!-- From admission to accommodation, we shoulder the journey
                    with you -->
                    From Admission to Placement, We Got You Covered
                  </p>
                  <div class="btn-flex">
                    <!-- <button
                      class="btn btn-success mr-1 mr-lg-4"
                      @click="$router.push({ path: '/contact-us' })"
                    >
                      Get expert counselling
                    </button> -->
                    <button @click="() => $router.push({ path: '/abroad-counselling' })
                      " class="btn btn-secondary-red">
                      Explore
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div class="service-box" id="toggle2" @mouseover="showContent(2)"
              :class="serviceId == 2 ? 'show-content' : 'hide-content'">
              <div class="service-img">
                <img src="@/assets/imgs/services_study.png" class="img-fluid" />
              </div>
              <div class="service-box-content">
                <div class="title">
                  <h4>IELTS</h4>
                </div>
                <hr class="line blue-line" />
                <div class="content">
                  <p>
                    <!-- English is a funny language! IELTS is an assessment of
                    English level - we do not teach or improve the language but
                    coach students for the pattern of the exam. But, you need to
                    unfortunately learn it like an expert to rule and conquer
                    the world. It is as absurd as it sounds and that’s why we
                    help you tweak that funny vocabulary and learn a thing or
                    two so that you can crack those exams that help you reserve
                    your seat in a university of your choice. Ready with your
                    game face? -->
                    <!-- Get the dream score to score the dream university -->
                    Turn your Distant Dreams to Reality by achieving the perfect
                    band score
                  </p>
                  <div class="btn-flex">
                    <!-- <button
                      class="btn btn-success mr-1 mr-lg-4"
                      @click="$router.push({ path: '/contact-us' })"
                    >
                      Get expert counselling
                    </button> -->
                    <button @click="() => $router.push({ path: '/ielts' })" class="btn btn-secondary-red">
                      Explore
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div class="service-box" id="toggle3" @mouseover="showContent(3)"
              :class="serviceId == 3 ? 'show-content' : 'hide-content'">
              <div class="service-img">
                <img src="@/assets/imgs/services_career.png" class="img-fluid" />
              </div>
              <div class="service-box-content">
                <div class="title">
                  <h4>CAREER COUNSELLING</h4>
                </div>
                <hr class="line yellow-line" />
                <div class="content">
                  <p>
                    <!-- You know more than us about yourself and your career
                    choices! Trust us when we tell you this, because what else
                    does a counsellor do? We hear you and tell you exactly what
                    you would love to hear. It is that simple. Jokes apart, we
                    also have a few expert skills up our sleeves and have been
                    told that we could help bring a difference to students’
                    lives for over decades now. Does this make us trustworthy?
                    Give a shoutout, please! -->

                    <!-- Career of your choice, made a reality with us! -->
                    Make Your Career Dreams a Reality with Our Expert Guidance
                  </p>
                  <div class="btn-flex">
                    <!-- <button
                      class="btn btn-success mr-1 mr-lg-4"
                      @click="$router.push({ path: '/contact-us' })"
                    >
                      Get expert counselling
                    </button> -->
                    <button @click="() => $router.push({ path: '/career-counselling' })
                      " class="btn btn-secondary-red">
                      Explore
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="scholarship-section section-spacing">
      <div class="container-fluid">
        <h2 class="main-heading-1-gradient text-center">
          $3.3+ Million Worth of Scholarships Awarded
        </h2>
        <p class="main-content-1 text-center mb-1">
          You don't necessarily need to be scholar to get one
        </p>
        <div class="row align-items-center">
          <div class="col-md-4 col-lg-4" data-aos="fade-right">
            <img src="@/assets/imgs/scholar.png" class="img-fluid border-all" />
          </div>
          <div class="col-md-4 col-lg-4 text-center py-lg-5" data-aos="fade-left">
            <!-- <p class="main-content-1 text-center mb-3">
              <b>Funding your dreams is made easier than you could dream of!</b>
            </p> -->
            <!-- <p class="main-content-1 text-center mb-1">
              <b>You don't necessarily need to be scholar to get one</b>
            </p> -->
            <p class="main-content-1 text-center mb-3">
              <b>You are just a click away from your dream scholarship</b>
            </p>
            <div>
              <a href="#contact-us-section" class="btn-secondary-red">Check your eligibility</a>
            </div>

            <!-- <p class="main-content-1 text-center">
              You are the leader of tomorrow and we help you build your pack
              today!
            </p>
            <div class="pt-3 pt-lg-5 text-center">
              <img
                src="@/assets/imgs/illustration-4.png"
                class="img-fluid border-all"
              />
            </div> -->
          </div>
          <div class="col-md-4 col-lg-4" data-aos="fade-right">
            <img src="@/assets/imgs/scholar-2.png" class="img-fluid border-all d-none d-md-block" />
          </div>
        </div>
      </div>
    </section>

    <section class="banner-lg-section section-all-spacing" data-aos="zoom" data-aos-duration="1000">
      <div class="container-fluid">
        <div class="row bg-primary-gradient bg-primary-responsive border-20 p-3 p-xl-5 flex h-35">
          <div class="col-lg-6">
            <h2 class="main-heading-1 w-70 mb-5" data-aos="fade-down">
              <!-- POWERFUL TECH TO HELP YOU CHOOSE YOUR EDUCATION PATH IN 3-CLICKS -->
              Get the edge over others with Edgeout
            </h2>
            <p class="main-content-1" data-aos="fade-up">
              <!-- Push yourself and get demanding of your own skills. Hone your
              strengths using tools that helps you discover your edge and
              perfect it with us to Shine On! -->
              Get the edge over global competition with our exclusive,
              personalized and expert guidance program.
            </p>
            <div class="mt-3 mt-lg-4" data-aos="fade-down">
              <button class="btn-secondary-red" @click="() => $router.push({ path: '/edgeout' })">
                Explore Edgeout
              </button>
            </div>
          </div>
          <div class="col-lg-6">
            <div class="illustration">
              <img src="@/assets/imgs/illustration-1.png" alt="" class="success-illustration" />
            </div>
          </div>
        </div>
      </div>
    </section>

    <b-modal id="event-modal" ref="event-modal" centered title="" cancel-disabled ok-disabled :hide-footer="true"
      size="lg">
      <div class="study-abroad-fair">
        <h1 class="main-heading-1-gradient">STUDY ABROAD FAIR</h1>

        <h3 class="">Master / MBA Programs</h3>
        <h4 class="main-content-1 mt-2">A post-grad focused education fair</h4>
        <div class="mt-4 font-weight-bold d-flex align-items-center">
          <img src="@/assets/imgs/svgs/sound.svg" alt="" class="img-fluid" width="50px" />
          <h4 class="main-content-1 pl-3">Last Call for 2022 Admissions</h4>
        </div>
        <div class="event-details popup-event-details">
          <div>
            <img src="@/assets/imgs/svgs/map.svg" alt="" class="img-fluid" />
            <p>Saturday, 28 May 2022</p>
          </div>
          <div>
            <img src="@/assets/imgs/svgs/clock.svg" alt="" class="img-fluid" />
            <p>11am to 5pm</p>
          </div>
          <div>
            <img src="@/assets/imgs/svgs/calendar.svg" alt="" class="img-fluid" />
            <p>Sofitel Hotel BKC</p>
          </div>
        </div>
        <button class="btn-secondary-red mt-3" @click="$router.push({ path: '/fair' })">
          Register Now
        </button>
      </div>
      <div class="fair-hero-img">
        <img src="@/assets/imgs/city.png" alt="" class="img-fluid" />
      </div>
    </b-modal>

    <section class="intro-sm-section section-spacing">
      <div class="container">
        <div class="row">
          <div class="col-md-6 col-lg-6" data-aos="fade-right">
            <img src="@/assets/imgs/illustration-2.png" class="img-fluid border-all p-4 p-lg-0" />
          </div>
          <div class="col-md-6 col-xl-6" data-aos="fade-left">
            <h2 class="main-heading-1-gradient">
              We guarantee 100% college admission, ensuring your peace of mind
            </h2>
            <p class="main-content-2">
              <!-- We understand your worries and know that it is all valid. But, we
              can at the same breath reassure you that we are there to help your
              kids excel in their abroad education plans, given our expertise
              and years of experience. -->
              Aliff is committed to ensuring your child's long-term success with
              a personalized approach that guarantees college admission and
              career success.
            </p>
            <div class="pt-3 pt-lg-5">
              <button class="btn-secondary-red" @click="$router.push({ path: '/office-locator' })">
                Enquire Now
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="destinations-section section-spacing">
      <div class="container-fluid">
        <div class="row justify-content-center">
          <div class="col-lg-6 text-center" data-aos="fade-up" data-aos-duration="500">
            <h2 class="main-heading-1-gradient text-center">The Viewfinder</h2>
            <p class="main-content-1">
              Make the world your classroom
            </p>
          </div>
          <div class="col-lg-12 pt-xl-5 mt-3">
            <slick ref="destinationSlider" :options="destinationSlider" class="destination-slider arrow-slider px-lg-5"
              v-if="getCountries.length > 0">
              <div data-aos="zoom-in" v-for="(country, index) in getCountries" :key="'country_cards_' + index" @click="e =>
                $router.push({
                  name: 'CountryAbout',
                  params: { country_key: country.country_key }
                })
                " class="dest-card">
                <div class="dest-img">
                  <img v-if="country.country_image" :src="country.country_image" class="img-fluid" />
                  <img v-else src="@/assets/imgs/dest.png" class="img-fluid" />
                </div>
                <div class="dest-content py-2">
                  <h4 class="">Study in {{ country.country_name }}</h4>
                </div>
              </div>
              <div data-aos="zoom-in" v-for="(country, index) in getCountries" :key="'country_cards_' + index" @click="e =>
                $router.push({
                  name: 'CountryAbout',
                  params: { country_key: country.country_key }
                })
                " class="dest-card">
                <div class="dest-img">
                  <img v-if="country.country_image" :src="country.country_image" class="img-fluid" />
                  <img v-else src="@/assets/imgs/dest.png" class="img-fluid" />
                </div>
                <div class="dest-content py-2">
                  <h4 class="">Study in {{ country.country_name }}</h4>
                </div>
              </div>
            </slick>
            <div class="search-tags pt-4">
              <div class="tag" data-aos="zoom-in" v-for="(country, index) in getCountries" :key="index" @click="e =>
                $router.push({
                  name: 'CountryAbout',
                  params: { country_key: country.country_key }
                })
                ">
                {{ country.country_name }}
              </div>
            </div>
            <div class="text-center mt-5">
              <button @click="e =>
                $router.push({
                  name: 'CountryAbout',
                  params: { country_key: country.country_key }
                })
                " class="btn-secondary-red">
                Explore Countries
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Expand Your Horizons-->
    <section class="university-section section-spacing">
      <div class="container-fluid">
        <div class="row justify-content-center">
          <div class="col-lg-6 text-center" data-aos="fade-up" data-aos-duration="500">
            <h2 class="main-heading-1-gradient text-center">
              Expand Your Horizons
            </h2>
            <p class="main-content-1">
              <!-- Global Education for Global Citizens of Tomorrow -->
              Choose your dream career through countless Universities
            </p>
          </div>
          <div class="col-lg-12 mt-3 pt-xl-5">
            <slick ref="logoSlider" :options="logoSlider" class="logo-slider" v-if="featured_universities.length > 0">
              <div v-for="(university, index) in featured_universities" :key="'featured_universities_' + index">
                <div class="logo-card">
                  <div class="logo-img">
                    <img :src="IMAGEURL + university[0].university_logo" class="img-fluid" @click="e =>
                      $router.push({
                        name: 'UniversityAbout',
                        params: {
                          university_id: university[0].university_id
                        }
                      })
                      " />
                  </div>
                </div>
                <div class="logo-card">
                  <div class="logo-img">
                    <img :src="IMAGEURL + university[1].university_logo" class="img-fluid" @click="e =>
                      $router.push({
                        name: 'UniversityAbout',
                        params: {
                          university_id: university[1].university_id
                        }
                      })
                      " />
                  </div>
                </div>
                <div class="logo-card">
                  <div class="logo-img">
                    <img :src="IMAGEURL + university[2].university_logo" class="img-fluid" @click="e =>
                      $router.push({
                        name: 'UniversityAbout',
                        params: {
                          university_id: university[2].university_id
                        }
                      })
                      " />
                  </div>
                </div>
              </div>
            </slick>
            <div class="text-center mt-5">
              <button @click="$router.push({ path: '/search/search' })" class="btn-secondary-red">
                Explore Universities
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- viewfinder -->
    <!-- <section class="university-section section-spacing">
      <div class="container-fluid">
        <div class="row justify-content-center">
          <div
            class="col-lg-6 text-center"
            data-aos="fade-up"
            data-aos-duration="500"
          >
            <h2 class="main-heading-1-gradient text-center">The Viewfinder</h2>
            <p class="main-content-1">

              Make the world your classroom
            </p>
          </div>
          <div class="col-lg-12 mt-3 pt-xl-5">
            <slick
              ref="logoSlider"
              :options="logoSlider"
              class="logo-slider"
              v-if="featured_universities.length > 0"
            >
              <div
                v-for="(university, index) in featured_universities"
                :key="'featured_universities_' + index"
              >
                <div class="logo-card">
                  <div class="logo-img">
                    <img
                      :src="university[0].university_logo"
                      class="img-fluid"
                      @click="
                        e =>
                          $router.push({
                            name: 'UniversityAbout',
                            params: {
                              university_id: university[0].university_id
                            }
                          })
                      "
                    />
                  </div>
                </div>
                <div class="logo-card">
                  <div class="logo-img">
                    <img
                      :src="university[1].university_logo"
                      class="img-fluid"
                      @click="
                        e =>
                          $router.push({
                            name: 'UniversityAbout',
                            params: {
                              university_id: university[1].university_id
                            }
                          })
                      "
                    />
                  </div>
                </div>
                <div class="logo-card">
                  <div class="logo-img">
                    <img
                      :src="university[2].university_logo"
                      class="img-fluid"
                      @click="
                        e =>
                          $router.push({
                            name: 'UniversityAbout',
                            params: {
                              university_id: university[2].university_id
                            }
                          })
                      "
                    />
                  </div>
                </div>
              </div>
            </slick>
            <div class="text-center mt-5">
              <button
                @click="$router.push({ path: '/search/search' })"
                class="btn-secondary-red"
              >
                Explore University
              </button>
            </div>
          </div>
        </div>
      </div>
    </section> -->
    <!-- viewfinder -->

    <!-- <section class="student-section py-xl-5 my-5">
      <div class="container-fluid bg-row py-5">
        <div class="row justify-content-center">
          <div class="col-lg-6 text-center">
            <div class="main-heading-1">Hear from our students</div>
            <div class="main-content-1">
              Your thoughts inspire us. It is the fuel that pumps us to go that
              extra mile. Hear what some of our past students have to say about
              us
            </div>
          </div>
          <div class="col-lg-12 mt-5">
            <VideoTestimonialSlider />
          </div>
        </div>
      </div>
    </section> -->

    <section class="d-none franchise-section section-spacing">
      <div class="container-fluid">
        <div class="row justify-content-center">
          <div class="col-lg-6 text-center" data-aos="fade-up" data-aos-duration="500">
            <h2 class="main-heading-1-gradient text-center">
              Aliff Franchise Partners
            </h2>
            <!-- <p class="main-content-1">
              We are a group of experienced and passionate people bringing our
              best counsel to help every kid realize their true potential. We go
              that extra mile to fulfil our aim of making the overseas education
              journey for every student, simple and effective.
            </p> -->
          </div>
          <div class="col-lg-12 mt-3 pt-xl-5">
            <div class="team-member-cards">
              <slick ref="teamIntroSlider" :options="teamIntroSlider"
                class="stu-card-slider green-slick-dots franchise-card-slider">
                <div class="cards">
                  <div class="team-member">
                    <img src="@/assets/imgs/franchise/1.png" alt="" />
                    <div class="team-overlay">
                      <div class="team-desc text-center">
                        <p class="franchise-number"><span>83569 91403</span></p>
                        <p><span>preeti@aliff.in</span></p>
                      </div>
                    </div>
                  </div>
                  <div>
                    <p class="franchise-name">Preeti Ganju</p>
                  </div>
                </div>
                <div class="cards">
                  <div class="team-member">
                    <img src="@/assets/imgs/franchise/2.png" alt="" />
                    <div class="team-overlay">
                      <div class="team-desc text-center">
                        <p class="franchise-number"><span>83569 73171</span></p>
                        <p><span>lopa@aliff.in</span></p>
                      </div>
                    </div>
                  </div>
                  <div>
                    <p class="franchise-name">Lopa Vyas</p>
                  </div>
                </div>
                <div class="cards">
                  <div class="team-member">
                    <img src="@/assets/imgs/franchise/3.png" alt="" />
                    <div class="team-overlay">
                      <div class="team-desc text-center">
                        <p class="franchise-number"><span>93213 06252</span></p>
                        <p><span>shabana@aliff.in</span></p>
                      </div>
                    </div>
                  </div>
                  <div>
                    <p class="franchise-name">Shabana Khan</p>
                  </div>
                </div>
                <div class="cards">
                  <div class="team-member">
                    <img src="@/assets/imgs/franchise/4.png" alt="" />
                    <div class="team-overlay">
                      <div class="team-desc text-center">
                        <p class="franchise-number"><span>93268 60910</span></p>
                        <p><span>worli@aliff.in</span></p>
                      </div>
                    </div>
                  </div>
                  <div>
                    <p class="franchise-name">Snehas Ajgaonkar</p>
                  </div>
                </div>
                <div class="cards">
                  <div class="team-member">
                    <img src="@/assets/imgs/franchise/5.png" alt="" />
                    <div class="team-overlay">
                      <div class="team-desc text-center">
                        <p class="franchise-number">
                          <span> 971 50 781 3413, 971 58 580 5879</span>
                        </p>
                        <p><span>dubai@aliff.in</span></p>
                      </div>
                    </div>
                  </div>
                  <div>
                    <p class="franchise-name">Shalini Singh</p>
                  </div>
                </div>
                <div class="cards">
                  <div class="team-member">
                    <img src="@/assets/imgs/franchise/6.png" alt="" />
                    <div class="team-overlay">
                      <div class="team-desc text-center">
                        <p class="franchise-number">
                          <span>965 506 33207</span>
                        </p>
                        <p>hina@aliff.in</p>
                      </div>
                    </div>
                  </div>
                  <div>
                    <p class="franchise-name">Hina Saleem</p>
                  </div>
                </div>
              </slick>
            </div>
            <!-- <div class="text-center pt-3">
              <button
                @click="() => $router.push({ path: '/about-us' })"
                class="btn-secondary-red"
              >
                Get to know us
              </button>
            </div> -->
          </div>
        </div>
      </div>
    </section>

    <!-- <section class="university-section section-spacing">
      <div class="container-fluid">
        <div class="row justify-content-center">
          <div
            class="col-lg-6 text-center"
            data-aos="fade-up"
            data-aos-duration="500"
          >
            <h2 class="main-heading-1-gradient text-center">
              Facilitator’s of your dream
            </h2>
            <p class="main-content-1">
              We are a group of experienced and passionate people bringing our
              best counsel to help every kid realize their true potential. We go
              that extra mile to fulfil our aim of making the overseas education
              journey for every student, simple and effective.
            </p>
          </div>
          <div class="col-lg-12 mt-3 pt-xl-5">
            <div class="team-member-cards">
              <slick
                ref="teamIntroSlider"
                :options="teamIntroSlider"
                class="stu-card-slider green-slick-dots"
              >
                <div class="cards">
                  <div class="team-member">
                    <img src="@/assets/imgs/Aslam-founder-1.png" alt="" />
                    <div class="name-title">Asslam Shaikh</div>
                    <p class="designation">Founder & CEO</p>
                  </div>
                </div>

                <div class="cards">
                  <div class="team-member">
                    <img src="@/assets/imgs/Utpaal-1.jpg" alt="" />
                    <div class="name-title">Utpal Acharya</div>
                    <p class="designation">Chief Strategy Officer</p>
                  </div>
                </div>
                <div class="cards">
                  <div class="team-member">
                    <img src="@/assets/imgs/Arshad.png" alt="" />
                    <div class="name-title">Arshad Kazi</div>
                    <p class="designation">Chief Technology Officer</p>
                  </div>
                </div>
                <div class="cards">
                  <div class="team-member">
                    <img src="@/assets/imgs/Jenny Dsa-1.jpg" alt="" />
                    <div class="name-title">Jenny Dsa</div>
                    <p class="designation">Head of Products</p>
                  </div>
                </div>
                <div class="cards">
                  <div class="team-member">
                    <img src="@/assets/imgs/Sanath-1.jpg" alt="" />
                    <div class="name-title">Sanath Shetty</div>
                    <p class="designation">Head of Engineering</p>
                  </div>
                </div>
                <div class="cards">
                  <div class="team-member">
                    <img src="@/assets/imgs/KKM-1.jpg" alt="" />
                    <div class="name-title">Kaustubh K Murkar</div>
                    <p class="designation">HOD - Media Strategy & Events</p>
                  </div>
                </div>
                <div class="cards">
                  <div class="team-member">
                    <img src="@/assets/imgs/neha.png" alt="" />
                    <div class="name-title">Neha Ved</div>
                    <p class="designation">Head of Communication</p>
                  </div>
                </div>
              </slick>
            </div>
            <div class="text-center pt-3">
              <button
                @click="() => $router.push({ path: '/about-us' })"
                class="btn-secondary-red"
              >
                Get to know us
              </button>
            </div>
          </div>
        </div>
      </div>
    </section> -->

    <section class="university-section section-spacing">
      <div class="container">
        <h2 class="main-heading-1-gradient text-center">
          Trusted by the leaders, experts, and thought leaders across the globe!
        </h2>
        <div class="row justify-content-center">
          <div class="col-lg-6 text-center" data-aos="fade-up" data-aos-duration="500">
            <!-- <p class="blue-section-title">
              Trusted by the leaders, experts, and thought leaders across the
              globe!
            </p> -->
          </div>
          <div class="col-lg-12 mt-3 pt-xl-5">
            <div class="trusted-logos-cards">
              <div class="cards">
                <div>
                  <img src="@/assets/imgs/BIA.png" alt="" />
                </div>
                <!-- <div>
                      <img src="@/assets/imgs/BNI.png" alt="" />
                    </div> -->
                <div>
                  <img src="@/assets/imgs/ICEF.png" alt="" />
                </div>
                <div>
                  <img src="@/assets/imgs/EU India.png" alt="" />
                </div>
                <div>
                  <img src="@/assets/imgs/USIIC.jpg" alt="" />
                </div>
                <div>
                  <img src="@/assets/imgs/usa_logo.jpg" alt="" width="188px">
                </div>
                <div>
                  <img src="@/assets/imgs/Indo.png" alt="" />
                </div>
                <div>
                  <img src="@/assets/imgs/Swiss Indian.png" alt="" />
                </div>
                <div>
                  <img src="@/assets/imgs/WEBA.png" alt="" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <ContactusSection :source="2" />
    <!-- <RecentPostSection
      :recentPostsData="recentPostData['home-page']['data-1']"
    /> -->
  </div>
</template>

<script>
import { search_tags, bottom_search_tags } from "@/data/homeData";
import { mapGetters } from "vuex";
import homeServices from "@/apiServices/homeServices";
import BookFreeCounselling from "@/components/partials/BookFreeCounselling.vue";
import RecentPostSection from "@/components/partials/RecentPostSection.vue";
import TextTestimonialSlider from "@/components/partials/TextTestimonialSlider.vue";
import VideoTestimonialSlider from "@/components/partials/VideoTestimonialSlider.vue";
import ContactusSection from "@/components/partials/ContactusSection.vue";
import TechServices from "@/components/partials/TechServices.vue";
import img1 from "@/assets/imgs/supplies/engineering.svg";
import img2 from "@/assets/imgs/supplies/Atom.png";
import img3 from "@/assets/imgs/supplies/Art.svg";
import img4 from "@/assets/imgs/supplies/business.svg";
import img5 from "@/assets/imgs/supplies/Scale-1.svg";
import img6 from "@/assets/imgs/supplies/video.svg";
import img7 from "@/assets/imgs/supplies/Medical-Bag.svg";
import img8 from "@/assets/imgs/supplies/eco.svg";
import { IMAGEURL } from "@/config";
export default {
  name: "Home",
  metaInfo: {
    title: "Best Overseas Education Consultants | Consultancy For Foreign Education",
    htmlAttrs: {
      lang: "en-US"
    },
    meta: [
      { charset: "utf-8" },
      {
        name: "description",
        content:
          "Overseas Education Consultants: Aliff Overseas is the ultimate solution for students who want to join top-ranking international universities without wasting time."
      },
      { name: "viewport", content: "width=device-width, initial-scale=1" },
      {
        name: "google-site-verification",
        content: "3AGVH8g4t8ldh8KcqAO8Ma3VnobGTNb-DxQdFoUQBTE"
      },
      { name: "msvalidate.01", content: "6E33F85EB785616D955B091C77828158" }
    ]
  },
  components: {
    BookFreeCounselling,
    RecentPostSection,
    TextTestimonialSlider,
    VideoTestimonialSlider,
    ContactusSection,
    TechServices
  },
  data() {
    return {
      IMAGEURL,
      yourArray: [
        { img: img1, title: "Engineering" },
        { img: img2, title: "Sciences" },
        { img: img3, title: "Arts" },
        { img: img4, title: "Business" },
        { img: img5, title: "Law" },
        { img: img6, title: "English Language" },
        { img: img7, title: "Medicine" },
        { img: img8, title: "Economics" }
      ],
      featured_universities: [],
      filter: {
        searchText: "",
        course_level: null,
        course_category: null,
        country: null
      },
      serviceId: 1,
      styleServicesRow: ["60%", "20%", "20%"],
      search_tags,
      bottom_search_tags,
      videoSlider: {
        //autoplay: true,
        //autoplaySpeed: 2500,
        arrows: false,
        dots: true,
        infinite: false,
        slidesToScroll: 1,
        slidesToShow: 2.5,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 1.5,
              slidesToScroll: 1
            }
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1
            }
          }
        ]
      },
      destinationSlider: {
        infinite: true,
        rows: 2,
        slidesPerRow: 1,
        slidesToShow: 4,
        slidesToScroll: 1,
        arrows: true,
        dots: false,
        autoplay: true,
        autoplaySpeed: 1000,
        cssEase: "ease",
        useTransform: true,
        speed: 1000,
        cssEase: "linear",
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 1.5,
              slidesToScroll: 1
            }
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 1.5,
              slidesToScroll: 1,
              arrows: false,
              dots: true
            }
          }
        ]
      },
      counsellorSlider: {
        autoplay: true,
        autoplaySpeed: 2500,
        arrows: true,
        dots: false,
        infinite: false,
        slidesToScroll: 1,
        slidesToShow: 4,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 1.5,
              slidesToScroll: 1
            }
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1
            }
          }
        ]
      },
      postSlider: {
        //autoplay: true,
        //autoplaySpeed: 2500,
        arrows: true,
        dots: false,
        infinite: false,
        slidesToScroll: 1,
        slidesToShow: 3,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1
            }
          },
          {
            breakpoint: 768,
            settings: {
              arrows: false,
              dots: true,
              slidesToShow: 1,
              slidesToScroll: 1
            }
          }
        ]
      },
      logoSlider: {
        infinite: true,
        slidesToShow: 6,
        slidesToScroll: 1,
        arrows: false,
        dots: false,
        autoplay: true,
        autoplaySpeed: 1000,
        speed: 3000,
        pauseOnHover: true,
        cssEase: "linear",
        centerMode: true,
        centerPadding: "30px",
        adaptiveHeight: false,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 4,
              slidesToScroll: 1
            }
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1
            }
          }
        ]
      },
      teamIntroSlider: {
        slidesToShow: 4.5,
        slidesToScroll: 1,
        arrows: false,
        dots: true,
        infinite: false,
        // autoplay: true,
        // autoplaySpeed: 0,
        // speed: 5000,
        // cssEase: "linear",
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 1.5,
              slidesToScroll: 1
            }
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 1.5,
              slidesToScroll: 1
            }
          }
        ]
      }
    };
  },
  mounted() {
    // this.openModal();
    // this.reInit();
    // this.$refs["event-modal"].show();

    // $('#event-modal').modal('show')

    if (window.innerWidth >= 1024) {
      this.styleServicesRow = ["60%", "20%", "20%"];
    } else {
      this.styleServicesRow = ["100%", "100%", "100%"];
    }
  },
  computed: {
    ...mapGetters(["getCountries"])
  },
  beforeUpdate() {
    // if (this.$refs.destinationSlider) {
    //   this.$refs.destinationSlider.destroy();
    // }
  },
  updated() {
    // this.$nextTick(function () {
    //   if (this.$refs.destinationSlider) {
    //     this.$refs.destinationSlider.create(this.slickOptions);
    //   }
    // });
  },
  methods: {
    onKeySearch(e) {
      if (e.keyCode === 13) {
        this.goToSearchPage();
      }
    },
    onClickSearchTag(tag_obj) {
      switch (tag_obj.type) {
        case "country":
          this.filter.country = tag_obj;
          break;

        case "course_level":
          this.filter.course_level = tag_obj;
          break;

        case "course_category":
          this.filter.course_category = tag_obj;
          break;

        case "search":
          this.filter.searchText = tag_obj.name;
          break;
      }
      this.goToSearchPage();
    },
    goToSearchPage() {
      window.courseFilter = this.filter;
      this.$router.push("/search/search");
    },
    showContent(id) {
      console.log(window.innerWidth);
      if (window.innerWidth >= 1024) {
        const newStyleServiceRow = this.styleServicesRow.map((val, i) =>
          i === id - 1 ? "60%" : "20%"
        );
        this.styleServicesRow = newStyleServiceRow;
      } else {
        this.styleServicesRow = ["100%", "100%", "100%"];
      }
      this.serviceId = id;
    },
    async getData() {
      try {
        const featured_universities = await homeServices.getFeaturedUniversities();
        if (featured_universities.data.status) {
          const data = featured_universities.data.data;
          let temp_arr = [];
          let i = 0;
          while (i < data.length) {
            let arr = [];
            arr.push(data[i]);
            arr.push(data[i + 1]);
            arr.push(data[i + 2]);
            temp_arr.push(arr);
            i = i + 3;
          }
          this.featured_universities = temp_arr;
        }
      } catch (err) {
        console.log("Error in getting data ", err);
      }
    }
  },
  beforeMount() {
    document.querySelector('meta[name="description"]').setAttribute('content', "Overseas Education Consultants: Aliff Overseas is the ultimate solution for students who want to join top-ranking international universities without wasting time.");

    this.getData();
  }
};
</script>
<style>
/* :root {
    --percentage: this.percentage;
} */
/* .custom-vertical-tabs .tab-active::before {
  background: red;
  width: var(--percentage);
  animation: animate-stripes 3s linear infinite;
} */
</style>



// WEBPACK FOOTER //
// src/components/pages/Home.vue